import React from 'react';
import TermsOfUseEn from "./TermsOfUseEn";
import TermsOfUseEs from "./TermsOfUseEs";
import TermsOfUseFr from "./TermsOfUseFr";
import {useIntl} from "react-intl";

import './TermsOfUseView.style.scss';
const TermsOfUseView = () => {
    const {locale} = useIntl();
    window.scrollTo(0, 0);

    return (
        <div className={'TermsOfUseView'}>
            {locale === "en" && <TermsOfUseEn/>}
            {locale === "fr" && <TermsOfUseFr/>}
            {locale === "es" && <TermsOfUseEs/>}
        </div>
    );
}


export default TermsOfUseView;